import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../generic/crud";
import {ENTITY_ID_BRANCH, ENTITY_ID_DEALER, ENTITY_ID_USER, ENTITY_ID_ADVISORS} from "../generic/Constants";
import {defaultBranch} from "../generic/InitialStates";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AGCText} from "../../generic-components/AGCText";
import {AGCSelect} from "../../generic-components/AGCSelect";


export function BranchAddEditDialog(props) {
    const {show, handleClose, id, onSave} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState(defaultBranch);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Branch");
    const entityName = "Branch";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(branch, {resetForm}) {
            setIsLoading(true);

            // Convert select objects to IDs
            branch.dealerId = branch.dealerId?.id || branch.dealerId;
            branch.managerId = branch.managerId?.id || branch.managerId;

            // Convert supervisorId array from objects to IDs
            if (branch.supervisorId && Array.isArray(branch.supervisorId)) {
                branch.supervisorId = branch.supervisorId.map(supervisor => supervisor.id || supervisor);
            }

            // Convert advisorIds array from objects to IDs
            if (branch.advisorIds && Array.isArray(branch.advisorIds)) {
                branch.advisorIds = branch.advisorIds.map(advisor => advisor.id || advisor);
            }

            if (!id) {
                apiGenericCreate(ENTITY_ID_BRANCH, branch).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_BRANCH, branch, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(true);

            genericGetOne(ENTITY_ID_BRANCH, id).then(
                ({data}) => {
                    // Convert IDs to select objects
                    data.dealerId = (data.dealerId && data.dealerId !== "") ? {id: data.dealerId, name: data.dealerName} : null;
                    data.managerId = (data.managerId && data.managerId !== "") ? {id: data.managerId, name: data.managerName} : null;

                    // Convert supervisorId array from IDs to select objects
                    if (data.supervisorId && data.supervisorId.length > 0 && data.supervisorName && data.supervisorName.length > 0) {
                        data.supervisorId = data.supervisorId.map((id, index) => ({
                            id: id,
                            name: data.supervisorName[index] || id
                        }));
                    } else {
                        data.supervisorId = [];
                    }

                    // Convert advisorIds array from IDs to select objects
                    if (data.advisorIds && data.advisorIds.length > 0 && data.advisorNames && data.advisorNames.length > 0) {
                        data.advisorIds = data.advisorIds.map((id, index) => ({
                            id: id,
                            name: data.advisorNames[index] || id
                        }));
                    } else {
                        data.advisorIds = [];
                    }

                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultBranch);
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Branch Name"}
                                         placeHolder={'Enter Branch Name'}
                                         id={"name"}
                                         toolTip={"Please enter the Branch Name"}
                                         value={formik.values.name}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCSelect
                                    formik={formik}
                                    isMulti={false}
                                    id={'dealerId'}
                                    name={"Select Dealer"}
                                    entityId={ENTITY_ID_DEALER}
                                    value={formik.values.dealerId}
                                    toolTip={"Please Select a Dealer"}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCSelect
                                    formik={formik}
                                    isMulti={false}
                                    id={'managerId'}
                                    name={"Select Manager"}
                                    entityId={ENTITY_ID_USER}
                                    value={formik.values.managerId}
                                    toolTip={"Please Select a Manager"}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCSelect
                                    formik={formik}
                                    isMulti={true}
                                    id={'supervisorId'}
                                    name={"Select Supervisors"}
                                    entityId={ENTITY_ID_USER}
                                    value={formik.values.supervisorId}
                                    toolTip={"Please Select Supervisors (you can select multiple)"}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCSelect
                                    formik={formik}
                                    isMulti={true}
                                    id={'advisorIds'}
                                    name={"Select Service Advisors"}
                                    entityId={ENTITY_ID_ADVISORS}
                                    value={formik.values.advisorIds}
                                    toolTip={"Please Select Service Advisors (you can select multiple)"}/>
                            </Form.Group>
                        </div>

                        <br/>
                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
